import React from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}
export function Textarea({
  label,
  error,
  className = '',
  id,
  ...props
}: TextareaProps) {
  const inputId = id || props.name;
  return <div className="w-full" data-id="element-104">
      {label && <label htmlFor={inputId} className="block text-sm font-bold text-brand-dark mb-1" data-id="element-105">
          {label}
        </label>}
      <textarea id={inputId} className={`w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-yellow focus:border-transparent transition-all min-h-[120px]
          ${error ? 'border-red-500' : 'border-gray-300'}
          ${className}`} {...props} data-id="element-106" />
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-107">{error}</p>}
    </div>;
}